var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M952 306L952 334",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 952.5,
    cy: 301.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M963.829 298.888L953.354 295.027C953.278 294.991 953.202 294.991 953.126 295.027L942.651 298.888C942.651 298.888 942.651 298.888 942.632 298.888C942.613 298.888 942.613 298.906 942.594 298.906C942.594 298.906 942.575 298.906 942.575 298.923C942.556 298.923 942.556 298.941 942.537 298.941C942.537 298.941 942.537 298.941 942.518 298.959C942.499 298.976 942.499 298.976 942.48 298.994C942.48 299.012 942.461 299.012 942.461 299.03V299.047C942.461 299.065 942.461 299.065 942.442 299.083V299.1C942.442 299.118 942.442 299.136 942.442 299.154V303.741C941.626 303.883 941 304.556 941 305.353C941 306.256 941.797 307 942.765 307C943.733 307 944.53 306.256 944.53 305.353C944.53 304.538 943.903 303.883 943.087 303.741V299.579L945.118 300.323V303.387C945.118 304.272 945.991 305.087 947.604 305.689C949.122 306.238 951.115 306.557 953.24 306.557C955.366 306.557 957.377 306.256 958.876 305.689C960.47 305.105 961.362 304.29 961.362 303.387V300.323L963.81 299.419C963.924 299.384 964 299.277 964 299.154C964 299.03 963.943 298.941 963.829 298.888ZM943.922 305.353C943.922 305.937 943.41 306.415 942.784 306.415C942.158 306.415 941.645 305.937 941.645 305.353C941.645 304.768 942.158 304.29 942.784 304.29C943.41 304.29 943.922 304.768 943.922 305.353ZM960.755 303.404C960.755 304.662 957.738 305.99 953.24 305.99C948.743 305.99 945.725 304.644 945.725 303.404V300.553L953.126 303.28C953.164 303.298 953.202 303.298 953.24 303.298C953.278 303.298 953.316 303.298 953.354 303.28L960.755 300.553V303.404ZM960.945 299.88L953.24 302.714L945.535 299.862L943.6 299.154L953.24 295.593L962.88 299.154L960.945 299.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool2);
export default __webpack_public_path__ + "static/media/school_2.f367a2b13a5326f2fdb941269736b125.svg";
export { ForwardRef as ReactComponent };